module.exports = __webpack_public_path__ + "static/media/gift-list1-active.5089bbb8.png";